/**
 * @flow
 */
import * as React from 'react';
import Header from './Layout/Header/index';
import Footer from './Layout/Footer';
import { Container, Row, Col } from 'reactstrap';
import { translate } from 'react-i18next';
const FontAwesome = require('react-fontawesome');

export class NoMatch extends React.Component<void, void> {
  render() {
    const { props: { t } } = this;
    return (
      <div style={{ height: '100%', minHeight: '100%' }}>
        <Header />
        <Container style={{ height: '100%', minHeight: '100%' }}>
          <Row style={{ height: '100%', minHeight: '100%' }}>
            <Col
              style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <FontAwesome name="exclamation" style={{ fontSize: '96px', color: '#CCCCCC' }} />
              <h1 style={{ color: 'rgba(162, 162, 162, 1)' }}>{t('Seite nicht gefunden')}</h1>
            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default translate()(NoMatch);



// WEBPACK FOOTER //
// ./src/App/NoMatch.js